import styled from 'styled-components';
import color from 'tinycolor2';
import { Button } from '@pearsontechnology/aero-components';

export const HorizontalLine = styled.div`
  position: relative;
  margin-left: ${(props) => props.isExpanded ? "30px" : "0px"};
  height: 2px;
  border-radius: 3px;
  margin-bottom: 5px;
  background-color:${(props) => color(props.theme['color.blueLight']).setAlpha(100).toString()};
}
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  z-index: 2;
  top: calc(50% - 15px);
  left: calc(50% - 15px);
  background-color: ${(props) => props.theme['color.background']};
  border-radius: 15px;
`;

export const InsertButtonIcon = styled(Button)`
  background-color:${(props) => color(props.theme['color.primary.text']).setAlpha(0.1).toString()};
`;
